import React from 'react'
import { LinkToProductItem } from '../Links/LinkToProductItem'
import { truncate } from '@ztechapps/common.utils'

export default function ProductInfo({ _id, code, name, summary, children }: any) {
  return (
    <div className="py-1">
      <div>
        <LinkToProductItem _id={_id} productCode={code}>
          {code} - {name}
        </LinkToProductItem>
      </div>

      <small>{truncate(summary, 200)}</small>
      <div>{children}</div>
    </div>
  )
}
